import { render, staticRenderFns } from "./SelectableCard.vue?vue&type=template&id=34477d81&scoped=true&"
import script from "./SelectableCard.vue?vue&type=script&lang=js&"
export * from "./SelectableCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectableCard.vue?vue&type=style&index=0&id=34477d81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34477d81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
